import React from "react";
import cn from "classnames";
import* as styles from "./HeaderMenuDropdown.module.scss";
import MenuItemHeadline from "./MenuItemHeadline/MenuItemHeadline";
import MenuItemTile from "./MenuItemTile/MenuItemTile";

function PlatformMenuDropdown() {
  return (
    <div className={styles.root}>
      <div className={styles.mainPartTiles}>
        <MenuItemHeadline>Building blocks</MenuItemHeadline>
        <div className={styles.mainTiles}>
          <MenuItemTile
            iconName={"puzzle"}
            color={"#00D2AB"}
            name={"Features"}
            href={"/features"}
            description={"Explore our most powerful features that go with every plan."}
          />
          <MenuItemTile
            iconName={"building-blocks"}
            color={"#FA3C4D"}
            name={"Templates"}
            href={"/templates"}
            description={"Discover, install and fully customize any template in minutes."}
          />
          <MenuItemTile
            iconName={"plug"}
            color={"#FF7E29"}
            name={"Integrations"}
            href={"/templates#integrations"}
            description={"Get a single connected workspace where all teams are welcome."}
          />
          <MenuItemTile
            iconName={"ai-sparkle"}
            color={"#FF5CA1"}
            name={"Fibery AI"}
            href={"/ai"}
            description={"Brainstorm, automate tasks, find relevant data, and experiment with your process."}
          />
        </div>
      </div>
      <div className={styles.additionalPartLinks}>
        <div className={styles.additionalPartGroup}>
          <MenuItemHeadline>Resources</MenuItemHeadline>
          <div className={styles.menuItemsGroup}>
            <div className={styles.menuSingleItem}>
              <a className={styles.dropdownLink} href="/customer-stories">
                Customer stories
              </a>
            </div>
            <div className={styles.menuSingleItem}>
              <a className={styles.dropdownLink} href="/download">
                Downloads
              </a>
            </div>
            <div className={cn(styles.menuSingleItem)}>
              <a
                className={styles.dropdownLink}
                href="https://the.fibery.io/@public/Changelog/Release-Notes-7884"
                target="_blank"
              >
                Changelog: Apr 24, 2025
                <span className={styles.releaseImage}>
                  <img
                    src="https://images-temp.fibery.io/website-static/release-images/release-cover-apr4.webp"
                    alt="release Apr 24, 2025"
                  />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlatformMenuDropdown;
